module.exports = __webpack_public_path__ + "img/belgravialdn-logo.b3ac90ff.jpeg";